import BackgroundWrapper from "_components/atoms/backgroundWrapper";
import Typography        from "_components/atoms/typography";
import ViewDetailedBtn   from "_components/features/creatorDashboard/atoms/viewDetailedBtn";
import Tabs              from "_components/features/creatorDashboard/molecules/tabs";
import FeedbackModal     from "_components/features/creatorDashboard/organisms/feedbackModal";
import StepperModal      from "_components/features/creatorDashboard/organisms/monetisationJourneyModal";

import Process   from "./hoc/process.js";
import useStyles from "./styles";

const Earning = props => {

	const {
		tabs,
		onClickHandler,
		monetisationData,
		intialMonetisationData,
		activeTab,
		setActiveTab,
		toggleFeedback,
		showFeedback,
		showTotalEarning,
		setMonetisationData,
		handleDetailedBtn,
		showStepperModal,
		toggleStepperModal,
		isMigratingData,
		isMobile

	} = props;

	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<BackgroundWrapper
			className = { classes.earningRoot }
			type      = "primary"
		>
			<Typography
				className = { classes.title }
				title     = { showTotalEarning ? "Earning" : "Earn" }
			/>

			{!showTotalEarning && (
				<Tabs
					activeTab      = { activeTab }
					defaultTab     = { activeTab }
					onClickHandler = { onClickHandler }
					setActiveTab   = { setActiveTab }
					tabs           = { tabs }
				/>
			)}

			<Process
				isMigratingData  = { isMigratingData }
				monetisationData = { monetisationData || intialMonetisationData }
				showTotalEarning = { showTotalEarning }
				toggleFeedback   = { toggleFeedback }
				type             = { activeTab }
			/>

			<FeedbackModal
				isMobile            = { isMobile }
				modal               = { showFeedback }
				setMonetisationData = { setMonetisationData }
				toggleFeedback      = { toggleFeedback }
				type                = { activeTab }
			/>

			<ViewDetailedBtn onClick = { handleDetailedBtn } />

			<StepperModal
				activeTabClicked   = { activeTab }
				isMigratingData    = { isMigratingData }
				isMobile           = { isMobile }
				showStepperModal   = { showStepperModal }
				toggleFeedback     = { toggleFeedback }
				toggleStepperModal = { toggleStepperModal }
			/>

		</BackgroundWrapper>
	);
};

export default Earning;

